import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AssistantRequest } from '../models/assitant-request';
import { DictionaryService } from 'src/app/services/dictionary.service';
import { DynamicEntityDataRequest } from 'src/app/models/dynamic-entity-data-request';
import { DynamicKeyValues } from 'src/app/models/dinamic-entity-key-values';
import { environment } from 'src/environments/environment';
import { MoovingAssistantIA } from '../models/assistant';
import { BehaviorSubject } from 'rxjs';
import { Conversation } from 'src/app/share/models/conversation';

@Injectable({
  providedIn: 'root'
})
export class AssistantService {

  $currentAssistant = new BehaviorSubject<MoovingAssistantIA | null>(null);

  constructor(private http: HttpClient, private dictionary: DictionaryService) { }

  sendMessage(body: AssistantRequest) {
    return this.http.post(`${environment.urlApi}/assistant/ask`, body);
  }

  setCurrentAssistant(moovingAssistant: MoovingAssistantIA | null) {
    this.$currentAssistant.next(moovingAssistant);
  }

  getAssistantByUserId(userId: string, pageNumber: number = 1, pageSize: number = 10) {

    const filters: DynamicKeyValues[] = [{
      field: 'idUser',
      value: userId
    }]

    const dataRequest: DynamicEntityDataRequest = {
      pageNumber: 1,
      pageSize: 10,
      filters: filters
    }

    return this.dictionary.getDynamicEntityRecords(dataRequest, environment.assistantEntityId)
  }

  getByOrganizationId(organizationId: number) {
    return this.http.get<MoovingAssistantIA[]>(`${environment.urlApi}/assistant/by-organization/${organizationId}`);
  }

  deleteAssistance(assistantId: string) {
    return this.dictionary.deleteRecord(environment.assistantEntityId, assistantId);
  }

  getAssistantByIdTelar(idTelar: string) {
    const filters: DynamicKeyValues[] = [{
      field: 'idTelar',
      value: idTelar
    }]

    const dataRequest: DynamicEntityDataRequest = {
      pageNumber: 1,
      pageSize: 10,
      filters: filters
    }

    return this.dictionary.getDynamicEntityRecords(dataRequest, environment.assistantEntityId);
  }

  getConversationsByUserIdAndAssistantId(userId: string, assistantIdTelar: string) {
    return this.http.get<Conversation[]>(`${environment.urlApi}/assistant/${userId}${assistantIdTelar}`);
  }
}
